import React from 'react';
import { cn } from '@core/ui';

export interface FormRowProps {
  label: string;
  /** Secondary explanation under the label, not under the control. */
  hint?: string;
  htmlFor?: string;
  /** Label column width. `sm` (≈100px) for property grids, `md` (≈160px) for settings. */
  labelWidth?: 'sm' | 'md';
  className?: string;
  children: React.ReactNode;
}

/**
 * Label-left row — the layout for settings screens and property grids
 * (macOS System Settings style). Controls are content-sized, not full-width.
 * See docs/ux/14-forms.md.
 */
export function FormRow({
  label,
  hint,
  htmlFor,
  labelWidth = 'md',
  className,
  children,
}: FormRowProps) {
  return (
    <div className={cn('flex items-start gap-4 py-2', className)}>
      <div className={cn('shrink-0 pt-1.5', labelWidth === 'sm' ? 'w-28' : 'w-40')}>
        <label htmlFor={htmlFor} className="text-sm text-muted-foreground">
          {label}
        </label>
        {hint && <p className="mt-0.5 text-xs text-muted-foreground/70">{hint}</p>}
      </div>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
